import { createGlobalStyle } from '@app/styled';
import { color, font } from '@app/theme';

import outlineReset from './outlineReset';
import { wistiaOverrideStyles } from './styles';

// to overwrite twig styles if have some bugs
const GlobalStyles = createGlobalStyle`
  [data-type="themeProvider"], .louis-portal {
    color: ${color('custom.content.primary')};
    font: 12px/16px ${font('family.graphik')};
  
    /* For overriding bootstrap and legacy lokalise styles. Should be removed once we remove Bootstrap and legacy. */ 
    input[type="file"],
    input[type="radio"],
    input[type="checkbox"] {
        margin: 0;
        top: 0;
        
        &:focus {
            outline: none;
        }
    }
  }

  ${outlineReset}
  ${wistiaOverrideStyles}
  h1, h2, h3, h4, h5, h6 {
    -webkit-font-smoothing: antialiased;
  }

  body {
    // Avoid jumping of the content that might be caused by disappearing scrollbar (TAPPS-244)
    overflow-y: scroll;
  }
`;

export default GlobalStyles;
